import { AvailabilityChange } from "PFTypes";

import { ChangelogItem } from "../changelog_item";
import { AvailabilityChangeGroup } from "./availability_change_group";
import { useAvailabilityChangelog } from "./hooks/use_availability_changelog";

type AvailabilityChangelogProps = {
  change: AvailabilityChange;
};

export const AvailabilityChangelog = ({ change }: AvailabilityChangelogProps) => {
  const { before, after } = change;
  const changelog = useAvailabilityChangelog(before, after);

  return (
    <ChangelogItem
      before={
        changelog.before.length ? <AvailabilityChangeGroup changelogElements={changelog.before} /> : null
      }
      after={changelog.after.length ? <AvailabilityChangeGroup changelogElements={changelog.after} /> : null}
    />
  );
};
